// extracted by mini-css-extract-plugin
export var statItem = "_kg-1";
export var statsRow = "_kg-0";